// extracted by mini-css-extract-plugin
export var alt = "PageIntro-module--alt--ba324";
export var descContainer = "PageIntro-module--descContainer--6fae1";
export var description = "PageIntro-module--description--64dab";
export var desktopOnly = "PageIntro-module--desktopOnly--5d3cb";
export var main = "PageIntro-module--main--86d96";
export var mobileOnly = "PageIntro-module--mobileOnly--518a5";
export var styledContainer = "PageIntro-module--styledContainer--d0a6a";
export var textLeft = "PageIntro-module--textLeft--2d3d5";
export var title = "PageIntro-module--title--f78aa";
export var title2 = "PageIntro-module--title2--390ff";
export var titleContainer = "PageIntro-module--titleContainer--a14d3";
export var visuallyHidden = "PageIntro-module--visuallyHidden--5429c";